var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-12 col-md-12"},[_c('div',{staticClass:"card p-3 mb-3"},[_c('div',{staticClass:"card-body"},[_vm._t("title"),_c('div',{staticClass:"card-text"},[_vm._t("body")],2)],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }